import "./AboutMe.css"

function AboutMe() {
    return(
    <>
        <h1 className="text">Who I Am:</h1>
        <p className="text info">I am a passionate and self-motivated software engineer with a strong foundation in web development technologies. I have a proven track record of delivering full-stack applications, collaborating effectively in teams, and solving complex problems. I am eager to grow in my career and passionate about continuous learning.</p>

    </>
    )
};

export default AboutMe;